import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import BedAllotmentCharge from './bed-allotment-charge';
import BedAllotmentChargeDetail from './bed-allotment-charge-detail';
import BedAllotmentChargeUpdate from './bed-allotment-charge-update';
import BedAllotmentChargeDeleteDialog from './bed-allotment-charge-delete-dialog';

const BedAllotmentChargeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<BedAllotmentCharge />} />
    <Route path="new" element={<BedAllotmentChargeUpdate />} />
    <Route path=":id">
      <Route index element={<BedAllotmentChargeDetail />} />
      <Route path="edit" element={<BedAllotmentChargeUpdate />} />
      <Route path="delete" element={<BedAllotmentChargeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default BedAllotmentChargeRoutes;
